import styled from 'styled-components'

import { defaultTheme } from '@/styles/themes'

type TagProps = {
  hasClick: boolean
}

export const Tag = styled.div<TagProps>`
  display: flex;
  span {
    max-height: 32px;
    text-align: center;
    border: 1px solid ${defaultTheme.colors.darkgray};
    color: ${defaultTheme.colors.darkgray};
    padding: 8px 16px;
    border-radius: 40px;
    font-weight: ${defaultTheme.fontWeights.semibold};
    font-size: ${defaultTheme.fontSizes.b4};
    cursor: ${({ hasClick }) => hasClick && 'pointer'};
    position: relative;
    z-index: 1;
    transition: all 0.3s;
    overflow: hidden;

    .fill {
      width: 100%;
      height: 100%;
      position: absolute;
      background: linear-gradient(135deg, #0abaad 0%, #065a5a 100%);
      transition-duration: 0.4s;
      top: 100%;
      left: 0;
      z-index: -1;
      border-radius: 40px;
    }

    &:hover {
      color: white;
      border: none;
      transform: scale(1.05);
      .fill {
        top: 0;
        transition-duration: 0.3s;
      }
    }

    &.selected {
      color: white;
      border: none;
      transform: scale(1.05);
      .fill {
        top: 0;
        transition-duration: 0.3s;
      }
    }
  }

  // TODO fazer responsividade mobile
  // border-radius: 8px;
  // padding: 6px 12px;
`
